<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BBL4Oy/tc-custom/9781453286807.jpg?1733108278033" alt="This image is the cover for the book Tek Vengeance, The TekWar Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tek Vengeance, The TekWar Series
      </h1>
      <p class="bookDescription body article font2">
        <b>With his fiancée about to testify against the Teklord drug cartels, PI Jack Cardigan is lured to Brazil in a deadly scheme that could spark a new TekWar.</b><br/>  A man in Berlin has just learned something that could save Jake Cardigan’s life. But before he can pass on this vital information, he dies under suspicious circumstances—setting off a chain reaction that will change Cardigan’s life forever, threatening to destroy every person he loves. Cardigan’s fiancée, Beth, goes to Berlin to testify against the ruthless drug cartel controlled by Sonny Hokori and the Teklords. Cardigan plans to be there to protect her against the nefarious assassins of the Teklords, but an urgent case calls him to Rio. By the time he realizes the Brazilian case is no more than a set-up to take him away from Beth, it may be too late to save her—and prevent a new round of TekWars from engulfing the earth. <i>This ebook features an illustrated biography of William Shatner including rare images and never-before-seen documents from the author’s personal collection.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Shatner
      </h2>
      
      <p class="authorDescription body article">William Shatner (b. 1931) is a Canadian actor, author, and film director, known for his irreverent charm and his star turn as Captain Kirk in the original <i>Star Trek </i>television series, as well as many other roles. Born and raised in Montreal, Quebec, Shatner was cast in <i>Star Trek</i> as the courageous, unpredictable Captain James T. Kirk in 1966. The show became a cult hit in syndication, leading to a number of spin-offs and movies. Shatner starred in seven <i>Star Trek</i> films beginning with <i>Star Trek: The Motion Picture</i> in 1979. He later played leading roles on the television series <i>T.J. Hooker</i> (1982&ndash;86) and <i>Boston Legal </i>(2004&ndash;08). Shatner has also published a number of novels, most notably <i>TekWar</i> (1989), a science-fiction thriller that inspired eight sequels as well as video games and a television series. When he isn&rsquo;t working, Shatner and his wife, Elizabeth, divide their time between Southern California and Kentucky.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b253530